import { Component, Inject } from "@angular/core";
import { StateService } from "@uirouter/angular";
import { MatDialog } from "@angular/material/dialog";
import { ConfirmDialog } from "../../../shared/confirm-dialog.component";
import { PersonDataService } from "../../../core/persons.dataservice";
import * as dataCore from "../../../core/datacore";

@Component({
    selector: "crew-person-role",
    template: require('./person.role.component.html'),
    styles: [require('../../../shared/nullable-date.css')]
})
export class PersonRoleComponent {

    From: Date;
    To: Date;

    public get checkFrom(): boolean {
        return !this.From;
    }

    public get checkTo(): boolean {
        return !this.To;
    }

    constructor(
        @Inject(PersonDataService.Id) private personDataService: PersonDataService,
        @Inject("personRole") public personRole: Nema.Crew.Model.PersonRole,
        @Inject("roleTypes") public roleTypes: Nema.Crew.Model.JobType[],
        private stateService: StateService,
        private dialog: MatDialog,
        @Inject('$log') private $log: ng.ILogService) {
        
        this.From = dataCore.addTimezoneOffset(this.personRole.From);
        this.To = dataCore.addTimezoneOffset(this.personRole.To);
    }

    public entityName = "Person Job Role";

    public editStateName = "app.resources.persons.roles.edit";

    public listStateName = "app.resources.persons.detail";

    public edit(): void {
        this.stateService.go(this.editStateName, { personRoleId: this.personRole.Id });
    }

    public delete(): void {

        var self = this;

        this.dialog
            .open(ConfirmDialog)
            .afterClosed()
            .subscribe(res => self.onDeleteEntity(self, res));
    }

    private onDeleteEntity(self: PersonRoleComponent, shouldDelete?: boolean) {
        if (shouldDelete) {

            self.personDataService.removeMapping(this.personRole, () => { });

            self.personDataService
                .save(self.personRole.Person)
                .then(() => self.backToList())
                .catch(err => self.$log.error("Error deleting the entity.\n\nError is: " + err));
        }
    }

    public backToList(): void {
        this.stateService.go(this.listStateName, { id: this.personRole.PersonId });
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/resources/persons/roles/person.role.component.ts